import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Checkbox from 'src/app/components/Checkbox';
import AutoSuggesterInput from 'src/app/components/AutoSuggesterInput';
import {
  experienceJobBlur,
  experienceJobChange,
  experienceJobFocus,
  experienceJobSetValidationMessage,
  experienceJobSuggestionsGet,
  experienceJobSuggestionsReset
} from 'src/app/redux/actions/registration/experience/experienceJob';
import autoSuggesterPropTypes from 'src/app/propTypes/autoSuggester';
import { experienceFormSetHasWorkingExperience } from 'src/app/redux/actions/registration/experience/experienceForm';


class ExperienceJobContainer extends React.Component {

  renderSuggestion = ({ suggestion }) => (
    <p data-test="text-job-suggestion">
      {
        suggestion.map(({ highlight, part }) => highlight ? <b key={ part }>{part}</b> : part)
      }
    </p>
  );

  clearSuggestions = () => {
    const { dispatch } = this.props;

    dispatch(experienceJobSuggestionsReset());
  };

  getSuggestions = ({ value }) => {
    const { dispatch } = this.props;
    dispatch(experienceJobSuggestionsGet(value));
  };

  toggleWorkExperience = () => {
    const { dispatch, hasWorkExperience } = this.props;

    dispatch(experienceFormSetHasWorkingExperience(!hasWorkExperience));
  };

  onChange = ({ target }, { newValue: value }) => {
    const { dispatch, markedAsWrong, apiError } = this.props;
    const { validationMessage } = target;

    dispatch(experienceJobChange({
      value,
      validationMessage,
      markedAsWrong,
      apiError
    }));
  };

  onFocus = () => {
    const { dispatch } = this.props;

    dispatch(experienceJobFocus());
  };

  onBlur = (event, { highlightedSuggestion }) => {
    if (!event || highlightedSuggestion) {
      return;
    }

    const { dispatch, markedAsWrong } = this.props;
    const { validationMessage } = event.target;

    dispatch(experienceJobBlur(markedAsWrong, validationMessage));
    dispatch(experienceJobSetValidationMessage(validationMessage));
  };


  render() {
    const {
      onChange,
      onBlur,
      onFocus,
      getSuggestions,
      clearSuggestions,
      toggleWorkExperience,
      renderSuggestion
    } = this;
    const {
      suggestions,
      value,
      validationMessage,
      focus,
      markedAsWrong,
      apiError,
      jobInputRef,
      hasWorkExperience,
      sending
    } = this.props;
    const noBlankLines = '^\\s*\\S+.*';

    return (
      <React.Fragment>
        <AutoSuggesterInput id="jobs"
                            pattern={ noBlankLines }
                            maxLength='100'
                            label="Aktualne stanowisko pracy"
                            inputRef={ jobInputRef }
                            disabled={ !hasWorkExperience || sending }
                            required={ hasWorkExperience }
                            getSuggestionValue={ ({ name }) => name }
                            dataTest="input-job"
                            { ...{
                              suggestions,
                              value,
                              validationMessage,
                              focus,
                              markedAsWrong,
                              apiError,
                              renderSuggestion,
                              onChange,
                              onBlur,
                              onFocus,
                              getSuggestions,
                              clearSuggestions
                            }
                            }
        />

        <Checkbox
          disabled={ sending }
          checked={ !hasWorkExperience }
          onClick={ toggleWorkExperience }
          data-test="checkbox-has-experience">
          Nie mam doświadczenia zawodowego
        </Checkbox>
      </React.Fragment>
    );
  }
}

ExperienceJobContainer.propTypes = {
  ...autoSuggesterPropTypes,
  hasWorkExperience: PropTypes.bool.isRequired,
  sending: PropTypes.bool.isRequired
};

const mapStateToProps = (store) => ({
  ...store.experienceJobReducer,
  ...store.experienceFormReducer
});

export default connect(mapStateToProps)(ExperienceJobContainer);
